import React, { useState, useEffect, useCallback } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import axios from 'axios';
import useAlertaOffline from '../../hooks/useAlertaOffline';

const RESTART_HEADER = { Authorization: 'Basic ' + btoa('Portal:Portal1163') };

// Mensagens rotativas para quando o servidor cai
const OFFLINE_TIPS = [
  'Já tentou desligar e ligar de novo? 🔌',
  'O servidor foi passear 🚶',
  'Houston, temos um problema 🚀',
  'Erro 404: servidor não encontrado 🤷',
  'Alguém esqueceu de pagar a conta? 💸',
];

const PingStatus = ({ pingUrl, restartKey, pingAuth, interval = 20000 }) => {
  const [online, setOnline]     = useState(null);
  const [hovering, setHovering] = useState(false);
  const [tipIndex]              = useState(() => Math.floor(Math.random() * OFFLINE_TIPS.length));

  useAlertaOffline(online === false);

  const ping = useCallback(async () => {
    try {
      const cfg = pingAuth ? { auth: pingAuth } : {};
      await axios.get(pingUrl, cfg);
      setOnline(true);
    } catch {
      setOnline(false);
    }
  }, [pingUrl, pingAuth]);

  const restart = useCallback(async () => {
    if (!window.confirm('Reiniciar o servidor?')) return;
    setOnline(null);
    try {
      await axios.post(
        `https://v1-csapi.compsoft.com.br:824/taskstart/${restartKey}`,
        null,
        { headers: RESTART_HEADER }
      );
    } catch (e) {
      console.error('Reiniciar falhou:', e);
    }
  }, [restartKey]);

  useEffect(() => {
    ping();
    if (!interval) return;
    const t = setInterval(ping, interval);
    return () => clearInterval(t);
  }, [ping, interval]);

  const dotClass = online === null ? 'cs-dot cs-dot-idle'
    : online ? 'cs-dot cs-dot-on'
    : 'cs-dot cs-dot-off';

  const label = online === null ? 'Verificando…' : online ? 'Online' : 'Offline';

  return (
    <span className="cs-ping-status">
      <span
        className={dotClass}
        title={label}
        onMouseEnter={() => online === false && setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      />
      {hovering && online === false && (
        <span className="ee-offline-tip">{OFFLINE_TIPS[tipIndex]}</span>
      )}
      {restartKey && (
        <button className="cs-restart-btn" onClick={restart} title="Reiniciar serviço">
          <FiRefreshCw size={11} />
        </button>
      )}
    </span>
  );
};

export default PingStatus;
